<template>
  <b-form-group>
    <h6 class="mb-1 font-size-md">
      <span
        v-if="required"
        class="text-danger ml-n1"
      >*</span>
      {{ $t("global.identity-number") }}
    </h6>
    <b-form-input
      v-model="currentAnswer"
      :disabled="!(editable || shouldEdit)"
      class="w-100"
      :placeholder="$t('global.please-enter') + $t('global.identity-number')"
      type="text"
      maxlength="10"
      :state="validateState"
      @blur="validate"
      @keyup="checkInput"
    />
    <b-form-invalid-feedback :state="validateState">
      {{
        currentAnswer
          ? $t("global.please-enter-correct")
          : $t("global.please-enter-required")
      }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
    },
    answer: {
      type: String,
    },
    required: {
      type: Boolean,
    },
    editable: {
      type: Boolean,
    },
  },
  data() {
    return {
      validateState: undefined,
      errorMessage: '',
      shouldEdit: false,
    };
  },
  computed: {
    currentAnswer: {
      get() {
        return this.answer;
      },
      set(value) {
        this.$emit('update:answer', value);
      },
    },
  },
  watch: {
    currentAnswer() {
      this.validate();
    },
  },
  created() {
    if (!this.currentAnswer) {
      this.shouldEdit = true;
    }
  },
  methods: {
    validate() {
      if (this.required) {
        if (!this.currentAnswer) {
          this.errorMessage = this.$t('pleaseEnter');
          this.validateState = false;
          return false;
        }
      }
      if (this.currentAnswer) {
        return this.validatePersonalID();
      }
      this.validateState = true;
      return true;
    },
    validatePersonalID() {
      const PIDRegex = /^[A-Za-z][1-2]([0-9]{8})$/;
      if (!PIDRegex.test(this.currentAnswer)) {
        this.errorMessage = this.$t('personalIDIncorrect');
        this.validateState = false;
        return false;
      }

      const lowerID = this.currentAnswer.toLowerCase().split('');
      const cityWeight = {
        a: 10,
        b: 11,
        c: 12,
        d: 13,
        e: 14,
        f: 15,
        g: 16,
        h: 17,
        i: 34,
        j: 18,
        k: 19,
        l: 20,
        m: 21,
        n: 22,
        o: 35,
        p: 23,
        q: 24,
        r: 25,
        s: 26,
        t: 27,
        u: 28,
        v: 29,
        w: 32,
        x: 30,
        y: 31,
        z: 33,
      };
      const cityNumber = cityWeight[lowerID[0]];
      const firstNumberConvert = Math.floor(cityNumber / 10) + (cityNumber % 10) * 9;
      const section1 = lowerID[1] * 8 + lowerID[2] * 7 + lowerID[3] * 6;
      const section2 = lowerID[4] * 5 + lowerID[5] * 4 + lowerID[6] * 3;
      const section3 = lowerID[7] * 2 + lowerID[8] * 1 + lowerID[9] * 1;
      const total = firstNumberConvert + section1 + section2 + section3;
      if (total % 10 !== 0) {
        this.errorMessage = this.$t('personalIDIncorrect');
        this.validateState = false;
        return false;
      }

      this.validateState = true;
      return true;
    },
    checkInput() {
      if (this.answer.length > 0) {
        this.currentAnswer = this.answer[0].toUpperCase() + this.answer.substring(1);
      }
    },
  },
};
</script>
